import React from 'react';
import 'components/css/custom-elements.css'

const TableEmptyState = (prop) => {
    return(
        <div className='font-14 color-grey-mid margin-top-20'>
            {prop.msg}
        </div>
    )
};

export default TableEmptyState